import { render, staticRenderFns } from "./AmmountPay.vue?vue&type=template&id=e9208488&"
import script from "./AmmountPay.vue?vue&type=script&lang=js&"
export * from "./AmmountPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports